import { MagnifyingGlassCircleIcon } from '@heroicons/react/24/outline';
import { Link, Spinner, Switch } from '@main/complykit';
import { useGenerateWorkosAdminLinkMutation } from '@main/graphql/features/GenerateWorkosAdminLink.generated';
import { useToggleAuditTrailMutation } from '@main/graphql/mutations/ToggleAuditTrail.admin.generated';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { WorkosAdminPortalIntent } from '@main/graphql/types.admin.generated';
import { DrawerProperty, errorToast } from '@main/ui';

export const AuditTrailSwitch = ({ orgId }: { orgId: string }) => {
  const { data, refetch: refetchOrg } = useGetOrganizationQuery({ orgId });
  const organization = data?.organizations_by_pk;
  const [toggleAuditTrail, { isLoading: isToggleAuditTrailLoading }] =
    useToggleAuditTrailMutation();
  const [generateWorkOSLink, { isLoading: isGeneratingLink }] =
    useGenerateWorkosAdminLinkMutation();

  if (!organization) {
    return null;
  }

  return (
    <DrawerProperty>
      <DrawerProperty.Label
        icon={MagnifyingGlassCircleIcon}
        id="audit-trail-label"
        htmlFor="audit-trail"
      >
        Audit trail
      </DrawerProperty.Label>
      <DrawerProperty.Content px={2} alignItems="center" display="flex" gap={3}>
        <Switch
          id="audit-trail"
          aria-labelledby="audit-trail-label"
          isSelected={organization.is_audit_trail_enabled}
          isPending={isToggleAuditTrailLoading}
          onChange={async () => {
            await toggleAuditTrail({ orgId }).unwrap();
            refetchOrg();
          }}
        />
        {organization.is_audit_trail_enabled && (
          <>
            <Link
              size="sm"
              isDisabled={isGeneratingLink}
              onPress={async () => {
                try {
                  const data = await generateWorkOSLink({
                    orgId: organization.id,
                    intent: WorkosAdminPortalIntent.AuditLogs,
                  }).unwrap();
                  data.generate_workos_admin_link?.link &&
                    window.open(data.generate_workos_admin_link.link, '_blank');
                } catch {
                  errorToast('Unable to generate workos admin link');
                }
              }}
            >
              View logs
            </Link>
            <Link
              size="sm"
              isDisabled={isGeneratingLink}
              onPress={async () => {
                try {
                  const data = await generateWorkOSLink({
                    orgId: organization.id,
                    intent: WorkosAdminPortalIntent.LogStreams,
                  }).unwrap();
                  data.generate_workos_admin_link?.link &&
                    window.open(data.generate_workos_admin_link.link, '_blank');
                } catch {
                  errorToast('Unable to generate workos admin link');
                }
              }}
            >
              Configure log stream
            </Link>
            {isGeneratingLink && <Spinner size="sm" />}
          </>
        )}
      </DrawerProperty.Content>
    </DrawerProperty>
  );
};
